var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { bindable } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import { UserModel, RoleUserModel } from "../../../../../models/manage/user.models";
import { ArrayUtils } from "../../../../../utilities/arrays";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
import { RequestClient } from "../../../../../services/basics/request-client.service";
import { StringUtilities } from "../../../../../utilities/strings";
import { ManageUsersClientService } from "../../../../../services/manage/manage-users.service";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
var ManageUser = /** @class */ (function () {
    function ManageUser(requestClient, userClaimsService, manageUsersService, notificationService, dialogClientService, i18N) {
        this.requestClient = requestClient;
        this.userClaimsService = userClaimsService;
        this.manageUsersService = manageUsersService;
        this.notificationService = notificationService;
        this.dialogClientService = dialogClientService;
        this.i18N = i18N;
        this.roleClientId = 0;
        this._password = undefined;
        this.confirmPassword = undefined;
        this.defaults = {
            password: "(^*#$&!@)", // some random string that is not quite common
        };
        this.setAutomatically = null;
        this.canEditUser = true;
        this.resettingTwoFactor = false;
        this.twoFactorReset = false;
        this.clientId = -1;
        this.hasClientRole = false;
        this.showClientRequiredError = false;
        this.canEditUser = this.userClaimsService.hasPermission(Claims.CanUpdateUsers);
    }
    Object.defineProperty(ManageUser.prototype, "newPassword", {
        get: function () {
            return this._password;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageUser.prototype, "canResetTwoFactor", {
        get: function () {
            return this.canEditUser && !this.twoFactorReset && !!this.user && this.user.twoFactorConfirmed;
        },
        enumerable: false,
        configurable: true
    });
    ManageUser.prototype.confirmResetTwoFactor = function () {
        var _this = this;
        if (!window["SystemJS"]) {
            require("" + "../../../../dialogs/generic-confirmation-dialog/generic-confirmation-dialog");
        }
        var model = {
            title: this.i18N.tr('two-factor-reset-text'),
            messages: [this.i18N.tr('two-factor-reset-confirm-text')],
            confirm: this.i18N.tr('confirm-text'),
            cancel: this.i18N.tr('cancel-text'),
            onCancel: function () { },
            onConfirm: function () { return _this.resetTwoFactor(); }
        };
        this.dialogClientService.show(DialogServiceConstants.URLs.GenericConfirmationDialog, model);
    };
    ManageUser.prototype.resetTwoFactor = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resettingTwoFactor = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.manageUsersService.resetTwoFactor(this.user.userId)];
                    case 2:
                        _a.sent();
                        // hidden locally rather than clearing user.twoFactorConfirmed, which would show up as an unsaved change
                        this.twoFactorReset = true;
                        this.notificationService.show(this.i18N.tr('two-factor-reset-text'), this.i18N.tr('two-factor-reset-success-text'), NotificationType.Success, 3000);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.show(this.i18N.tr('error-text') + "!", this.i18N.tr('two-factor-reset-failed-text'), NotificationType.Error, 5000);
                        return [3 /*break*/, 5];
                    case 4:
                        this.resettingTwoFactor = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ManageUser.prototype, "defaultMockPassword", {
        get: function () {
            return this.defaults.password;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageUser.prototype, "getUpdatedPassword", {
        get: function () {
            return this.isPasswordUpdated ? this._password : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageUser.prototype, "isPasswordUpdated", {
        get: function () {
            return this._password !== this.defaultMockPassword;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageUser.prototype, "password", {
        set: function (val) {
            var _this = this;
            if (val === null) {
                this.setAutomatically = null;
                this.confirmPassword = undefined;
            }
            else if (this.user) {
                if (val === this.defaultMockPassword && this.setAutomatically === null) {
                    setTimeout(function () {
                        _this.setAutomatically = true;
                        _this.confirmPassword = undefined;
                    });
                }
                else if (this.setAutomatically === true) {
                    setTimeout(function () {
                        _this.setAutomatically = false;
                        if (val.length === _this.defaultMockPassword.length + 1) {
                            _this.passVM.clearField();
                            for (var i = 0; i < val.length; i++) {
                                if (i >= _this.defaultMockPassword.length || _this.defaultMockPassword.charAt(i) !== val.charAt(i)) {
                                    val = val.charAt(i);
                                    break;
                                }
                            }
                            _this.passVM.value = val;
                        }
                    });
                }
            }
            this._password = val;
        },
        enumerable: false,
        configurable: true
    });
    ManageUser.prototype.userHasChanged = function (newValue, oldValue) {
        var _this = this;
        this.password = null;
        this.confirmPassword = undefined;
        this.twoFactorReset = false;
        if (newValue && newValue.userId > 0 && newValue.passwordHash) {
            this.passVM.value = this.defaultMockPassword;
        }
        else {
            this.passVM.value = null;
        }
        if (newValue && this.user.roleUsers) {
            if (this.user.userId === 0) {
                this.user.passwordHash = null;
            }
            if (this.user) {
                this.hasClientRole = this.user.roleUsers.some(function (x) { return x.role && (StringUtilities.startsWith(x.role.roleName, "Client")); });
                this.clientId = -1;
                if (this.hasClientRole && this.clientAssociationEnabled) {
                    //can't find ClientUsers endpoint anywhere, get<{items: UserModel}> is wrong here because UserModel
                    //doesn't have clientId. The call doesn't seem to be used anywhere. setting it to items: any for now
                    this.requestClient.get("ClientUsers/GetClientByUserId", { id: newValue.userId }).then(function (x) {
                        if (x && x.items) {
                            var client = x.items[0];
                            if (client) {
                                _this.clientId = client.clientId;
                            }
                            else {
                                _this.clientId = null;
                            }
                        }
                    }, function (e) { });
                }
            }
        }
    };
    ManageUser.prototype.attached = function () {
        if (this.user && this.user.userId > 0 && this.user.passwordHash) {
            this.passVM.value = this.defaultMockPassword;
        }
        this._password = null;
    };
    ManageUser.prototype.removeRole = function (item) {
        var _this = this;
        ArrayUtils.remove(this.user.roleUsers, item);
        this.hasClientRole = this.user.roleUsers.some(function (x) { return x.roleId === _this.roleClientId; });
    };
    ManageUser.prototype.addRole = function () {
        this.user.roleUsers.push(new RoleUserModel(this.user));
    };
    ManageUser.prototype.roleChanged = function ($event, $index) {
        var _this = this;
        var roleClientName;
        if ($event.detail && $event.detail.item) {
            roleClientName = $event.detail.item.name;
        }
        else if ($event.detail && $event.detail.newValue) {
            roleClientName = $event.detail.newValue.name;
        }
        else {
            return;
        }
        if (roleClientName.startsWith("Client")) {
            this.roleClientId = $event.detail.item.id;
            this.hasClientRole = true;
        }
        else {
            this.hasClientRole = this.user.roleUsers.some(function (x) { return x.roleId === _this.roleClientId; });
            if (this.hasClientRole && (this.user.roleUsers[$index].roleId === this.roleClientId)) {
                this.hasClientRole = false;
            }
        }
        if (!this.hasClientRole) {
            this.clientId = -1;
        }
    };
    ManageUser.prototype.addContactNumber = function () {
        var userContactNumber = {
            userId: this.user.userId,
            phoneNumber: null,
            phoneNumberType: -1,
            phoneSequence: 0,
            phoneID: 0
        };
        this.user.userPhoneNumbers.push(userContactNumber);
    };
    ManageUser.prototype.removeContactNumber = function (item) {
        ArrayUtils.remove(this.user.userPhoneNumbers, item);
    };
    Object.defineProperty(ManageUser.prototype, "isConfirmPasswordMatched", {
        get: function () {
            if (this.setAutomatically)
                return true;
            if (this.newPassword === this.confirmPassword)
                return true;
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageUser.prototype, "validateUpdatedPassword", {
        get: function () {
            // password was set automatically and its not changed manually by the user then no issue
            if (this.setAutomatically)
                return true;
            // if password was changed by the user and the new password matches the default password, 
            // then show a validation error to change the password
            if (this.newPassword === this.defaultMockPassword)
                return false;
            if (this.newPassword === "")
                return false;
            return true;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ManageUser.prototype, "clientId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", UserModel)
    ], ManageUser.prototype, "user", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ManageUser.prototype, "clientAssociationEnabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ManageUser.prototype, "hasClientRole", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ManageUser.prototype, "showClientRequiredError", void 0);
    ManageUser = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [RequestClient, UserClaimsService,
            ManageUsersClientService, NotificationClientService,
            DialogClientService, I18N])
    ], ManageUser);
    return ManageUser;
}());
export { ManageUser };
